import { DEFAULT_TOAST_LIFE } from "../../../../common/EzToast";
import { CompaniesService } from "../../../../services";
import { goBack } from "../../../../utils/gotoback";
import {
  FETCH_COMPANIES_INIT,
  FETCH_COMPANIES_LIST,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  INIT_CREATE_COMPANIES_SCREEN,
  CREATE_COMPANIES,
  EDIT_COMPANIES,
  TOAST,
  FETCH_COMPANIES_DETAIL,
  COMPANIES_SAVE_TABLE_STATE,
  DELETE_COMPANIES,
  FETCH_COMPANY_DROPDOWN_LIST,
  SET_SELECTED_COMPANY,
  SWITCH_COMPANY,
} from "../../../types/Systems/Companies.type";

export const initializeCompaniesScreen = () => ({ type: FETCH_COMPANIES_INIT });

export const companiesFetchStart = (payload) => ({
  type: FETCH_COMPANIES_LIST.START,
  payload,
});

export const companiesFetchSuccess = (payload) => ({
  type: FETCH_COMPANIES_LIST.SUCCESS,
  payload,
});

export const companiesFetchError = (payload) => ({
  type: FETCH_COMPANIES_LIST.ERROR,
  payload,
});

export const fetchCompanies = (payload) => {
  return (dispatch) => {
    dispatch(companiesFetchStart(payload));
    CompaniesService.fetchCompanies(payload).then((data) => {
      if (!data.isError) {
        dispatch(companiesFetchSuccess(data));
      } else {
        dispatch(companiesFetchError(data));
      }
    });
  };
};

export const setDeleteConfirmationPopupVisibility = (payload) => ({
  type: SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  payload,
});

export const saveCompaniesTableState = (tableState) => ({
  type: COMPANIES_SAVE_TABLE_STATE,
  payload: tableState,
});

// Detail
export const companiesDetailFetchStart = (payload) => ({
  type: FETCH_COMPANIES_DETAIL.START,
  payload,
});

export const companiesDetailFetchSuccess = (payload) => ({
  type: FETCH_COMPANIES_DETAIL.SUCCESS,
  payload,
});

export const companiesDetailFetchError = (payload) => ({
  type: FETCH_COMPANIES_DETAIL.ERROR,
  payload,
});

export const fetchCompaniesById = (payload) => {
  return (dispatch) => {
    dispatch(companiesDetailFetchStart(payload));
    CompaniesService.fetchCompaniesById(payload).then((data) => {
      if (!data.isError) {
        dispatch(companiesDetailFetchSuccess(data));
      } else {
        dispatch(companiesDetailFetchError(data));
      }
    });
  };
};

// Init Create Screen
export const createCompaniesScreenInitStart = (payload) => ({
  type: INIT_CREATE_COMPANIES_SCREEN,
  payload,
});

export const initCreateCompaniesScreen = (payload) => {
  return (dispatch) => {
    dispatch(createCompaniesScreenInitStart());
  };
};

// Create
export const createCompaniesStart = () => ({
  type: CREATE_COMPANIES.START,
});

export const createCompaniesSuccess = (payload) => ({
  type: CREATE_COMPANIES.SUCCESS,
  payload,
});

export const createCompaniesError = (payload) => ({
  type: CREATE_COMPANIES.ERROR,
  payload,
});

export const resetToast = (payload) => ({
  type: TOAST.RESET,
  payload,
});

export const createCompanies = (payload) => {
  return (dispatch) => {
    dispatch(createCompaniesStart());
    CompaniesService.createCompanies(payload).then((data) => {
      if (!data.isError) {
        dispatch(createCompaniesSuccess());
        goBack();
      } else {
        dispatch(createCompaniesError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

// Edit
export const editCompaniesStart = (payload) => ({
  type: EDIT_COMPANIES.START,
  payload,
});

export const editCompaniesSuccess = (payload) => ({
  type: EDIT_COMPANIES.SUCCESS,
  payload,
});

export const editCompaniesError = (payload) => ({
  type: EDIT_COMPANIES.ERROR,
  payload,
});

export const editCompanies = (payload) => {
  return (dispatch) => {
    dispatch(editCompaniesStart());
    CompaniesService.editCompanies(payload).then((data) => {
      if (!data.isError) {
        dispatch(editCompaniesSuccess());
        dispatch(fetchCompaniesById({ id: payload.id }));
      } else {
        dispatch(editCompaniesError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

// Delete
export const deleteCompaniesStart = () => ({
  type: DELETE_COMPANIES.START,
});

export const deleteCompaniesSuccess = (payload) => ({
  type: DELETE_COMPANIES.SUCCESS,
  payload,
});

export const deleteCompaniesError = (payload) => ({
  type: DELETE_COMPANIES.ERROR,
  payload,
});

export const deleteCompanies = (payload) => {
  return (dispatch) => {
    dispatch(deleteCompaniesStart());
    CompaniesService.deleteCompanies({ id: payload.id }).then((data) => {
      if (!data.isError) {
        dispatch(deleteCompaniesSuccess());
        dispatch(setDeleteConfirmationPopupVisibility(false));
        // Refresh the list using passed params from EzTable
        if (payload.params) {
          dispatch(fetchCompanies(payload.params));
        } else {
          dispatch(fetchCompanies({ sortField: "id", pageSize: 10 }));
        }
      } else {
        dispatch(deleteCompaniesError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const companyDropdownFetchStart = () => ({
  type: FETCH_COMPANY_DROPDOWN_LIST.START,
});

export const companyDropdownFetchSuccess = (payload) => ({
  type: FETCH_COMPANY_DROPDOWN_LIST.SUCCESS,
  payload,
});

export const companyDropdownFetchError = (payload) => ({
  type: FETCH_COMPANY_DROPDOWN_LIST.ERROR,
  payload,
});

export const fetchCompanyDropdownList = () => {
  return (dispatch) => {
    dispatch(companyDropdownFetchStart());
    CompaniesService.fetchCompanyDropdownList().then((data) => {
      if (!data.isError) {
        dispatch(companyDropdownFetchSuccess(data));
      } else {
        dispatch(companyDropdownFetchError(data));
      }
    });
  };
};

export const setSelectedCompany = (payload) => ({
  type: SET_SELECTED_COMPANY,
  payload,
});

export const switchCompanyStart = () => ({
  type: SWITCH_COMPANY.START,
});

export const switchCompanySuccess = (payload) => ({
  type: SWITCH_COMPANY.SUCCESS,
  payload,
});

export const switchCompanyError = (payload) => ({
  type: SWITCH_COMPANY.ERROR,
  payload,
});

export const switchCompany = (payload) => {
  return (dispatch) => {
    dispatch(switchCompanyStart());
    CompaniesService.switchCompany(payload).then((data) => {
      if (!data.isError) {
        dispatch(switchCompanySuccess(data));
      } else {
        dispatch(switchCompanyError(data));
      }
    });
  };
};
